;(function() {
  'use strict'

  config.$inject = ["$stateProvider"];
  var dependencies = []

  angular.module('app.element', dependencies).config(config)

  // --------------------

  /* @ngInject */
  function config($stateProvider) {
    // search results and activity-stream-items can
    // return any of the element types: 'place', 'product', or undefined
    // so we handle it with multiple states pointing to the same view+controller pair
    $stateProvider
      .state('app.portal.element', {
        url: '/element/:id',
        templateUrl: 'element.template.html',
        controller: 'Element',
        hide: true,
      })
      .state('app.portal.place', {
        url: '/place/:id',
        templateUrl: 'element.template.html',
        controller: 'Element',
        hide: true,
      })
      .state('app.portal.product', {
        url: '/product/:id',
        templateUrl: 'element.template.html',
        controller: 'Element',
        hide: true,
      })
      .state('app.portal.other', {
        url: '/other/:id',
        templateUrl: 'element.template.html',
        controller: 'Element',
        hide: true,
      })
  }
})()
